<template>
  <!-- 錯誤訊息 -->
  <v-snackbar v-if="started"
    v-model="hasError"
    color="error"
    :timeout="2000">
    {{ $t(Words.ErrorOnRead) }}
    <template v-slot:actions>
      <v-btn
        variant="text"
        @click="hasError = false">
        {{ $t(Words.OK) }}
      </v-btn>
    </template>
  </v-snackbar>
  <!-- Modal Loader -->
  <ModalOpener v-model="modalVisible">
    <template #dialog="{ props }">
      <v-dialog
        v-model="modalVisible"
        persistent
        width="auto">
        <v-card color="primary">
          <v-card-text>
            {{ progressPercent === null ? $t(Words.Loading) : `${$t(Words.Loading)} ${progressPercent}%` }}
            <v-progress-linear
              :indeterminate="progressPercent === null"
              :model-value="progressPercent ?? 0"
              color="white"
              class="mb-0" />
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
  </ModalOpener>
</template>


<script lang="ts">

export interface LoaderOptions {
  /** 是否自動處理錯誤 */
  handleError?: boolean
  /** 讀取進度，0-100。 */
  progress?: { value: number | null }
}

</script>

<script setup lang="ts">
const modalVisible = ref(false)
const hasError = ref(false)

const started = ref(false)
const finished = computed(() => started.value && !modalVisible.value && !hasError.value)

const props = withDefaults(defineProps<{
  /** 檔案來源 URL */
  loader: Promise<any>,
} & LoaderOptions>(), {
  /** 是否自動處理錯誤 */
  handleError: true
})

const progressPercent = computed(() => {
  const value = props.progress?.value
  return typeof value === 'number' ? Math.max(0, Math.min(100, Math.round(value))) : null
})

function start() {
  started.value = true
  modalVisible.value = true

  return useWaitAtLeast(props.loader, 300)
    .then(result => {
      // 如果發生 API 錯誤，直接處理訊息
      if (props.handleError && result?.error?.value) {
        handleException(result.error)
        throw result.error
      }
      return result
    })
    .catch(e => {
      hasError.value = true
      throw e
    })
    .finally(() => {
      modalVisible.value = false
    })
}

defineExpose({
  start,
  finished,
})

</script>
